class XmlParser {
  Parse(xmlData, tag) {
    const regex = new RegExp(`<${tag}>(.*?)</${tag}>`, 's');
    const match = xmlData.match(regex);
    return match ? match[1].trim() : null;
  }
}

export default XmlParser;
